import { render } from "./HistoryPage.vue?vue&type=template&id=40f78013"
import script from "./HistoryPage.vue?vue&type=script&lang=js"
export * from "./HistoryPage.vue?vue&type=script&lang=js"

import "./HistoryPage.vue?vue&type=style&index=0&id=40f78013&lang=scss"

import exportComponent from "C:\\Users\\chervinskii_mk\\Documents\\ORIS\\Repositories\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__